var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10024 6.8H4.06344C2.80797 6.8 1.84357 7.89235 2.02112 9.11328L2.46321 12.1533C2.6084 13.1517 3.47885 13.8933 4.50553 13.8933H7.40091C7.64645 12.4556 8.91934 11.36 10.4527 11.36H13.5473C15.0807 11.36 16.3535 12.4556 16.5991 13.8933H19.4945C20.5212 13.8933 21.3916 13.1517 21.5368 12.1533L21.9789 9.11328C22.1564 7.89235 21.192 6.8 19.9366 6.8H16.8998V4.78667C16.8998 3.24763 15.6297 2 14.0631 2H9.93694C8.37027 2 7.10024 3.24763 7.10024 4.78667V6.8ZM8.64753 4.78667C8.64753 4.08711 9.22482 3.52 9.93694 3.52H14.0631C14.7752 3.52 15.3525 4.08711 15.3525 4.78667V6.8H8.64753V4.78667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53422 15.4133C7.95904 16.5941 9.10531 17.44 10.4527 17.44H13.5473C14.8947 17.44 16.041 16.5941 16.4658 15.4133H19.4945C19.8773 15.4133 20.2477 15.3544 20.5961 15.2448L21.1703 20.8858C21.2311 21.4824 20.7542 22 20.1439 22H3.85608C3.24581 22 2.76895 21.4824 2.82968 20.8858L3.40391 15.2448C3.75228 15.3544 4.1227 15.4133 4.50554 15.4133H7.53422Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9054 14.4C8.9054 13.5605 9.59815 12.88 10.4527 12.88H13.5473C14.4018 12.88 15.0946 13.5605 15.0946 14.4C15.0946 15.2395 14.4018 15.92 13.5473 15.92H10.4527C9.59815 15.92 8.9054 15.2395 8.9054 14.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.9b00b2165c6b1644e649162ec8a57895.svg";
export { ForwardRef as ReactComponent };